const resinsStore = {
	namespaced: true,
	state: () => ({
		me: 'resins',
		sandBox: null,
		activeItem: null,
		resinsCollection: RESINS_COLLECTION,
		flowResinsCollection: FLOW_RESINS_COLLECTION,
		pacDentCollection: PAC_DENT_COLLECTION,
		selectedProductId: '6893565673575', // Default product ID for resinsCollection
		selectedFlowResinProductId: '6981479923815', // Default product ID for flowResinsCollection
		selectedPacDentProductId: '7345430462567',
	}),
	getters: {
		activeItem: (state) => {
			return state.activeItem;
		},
		selectedShopifyProduct: (state) => {
			const selectedProduct = state.resinsCollection.find((m) => m.id == state.selectedProductId);
			//console.log('Selected Product ID:', state.selectedProductId)
			return selectedProduct;
		},
		selectedFlowResinShopifyProduct: (state) => {
			const selectedProduct = state.flowResinsCollection.find(
				(m) => m.id == state.selectedFlowResinProductId,
			);
			// console.log('Selected Flow Resin Product ID:', state.selectedFlowResinProductId)
			return selectedProduct;
		},
		selectedPacDentShopifyProduct: (state) => {
			const selectedProduct = state.pacDentCollection.find(
				(m) => m.id == state.selectedPacDentProductId,
			);
			return selectedProduct;
		},
	},
	mutations: {
		setActiveItem(state, item) {
			state.activeItem = item;
		},
		setSelectedProductId(state, productId) {
			//console.log('setSelectedProductId mutation called with', productId)
			state.selectedProductId = productId;
		},
		setSelectedFlowResinProductId(state, productId) {
			state.selectedFlowResinProductId = productId;
		},
		setSelectedPacDentProductId(state, productId) {
			state.selectedPacDentProductId = productId;
		},
	},
	actions: {
		sayHi() {
			appLog.log('HIIIIII resins');
		},

		menuItemClick({ commit }, item) {
			commit('setActiveItem', item);
			commit('setSelectedProductId', item.productId);
			commit('setSelectedFlowResinProductId', item.productId);
			commit('setSelectedPacDentProductId', item.productId);
		},
	},
};

vStore.registerModule('resins', resinsStore);
